// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Veille stratégique`,
    h229e7d06093c2f3f: html `ESG et diversité`,
    h4b6568de605796be: html `Conseils d'administration et gouvernance`,
    h4e84df3b11ed9b4f: html `Aide et assistance`,
    h722c4148bfbe6706: html `Formation et certifications`,
    h85f4df4fdcb8beed: html `Risque et stratégie`,
    hb6b70f369f25a7ac: html `Conformité et éthique`,
    hc639dc8eaab7815d: html `Problèmes et rapports`,
    hcd22a6d6c40d8786: html `Audits et analyses`,
    "link-home": `Accueil`,
    "nav-section-home": `Accueil`,
    s032cd9f1245d3645: `Espace`,
    s08e6d298452e8f68: `Audit`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Ouvrir la boîte de dialogue des raccourcis clavier`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Stock d'actifs`,
    s14ba513bc8896c24: `Robots`,
    s1534ff9f453525e1: `Sélectionner la première cellule`,
    s175d37c8eb04d73e: `Téléchargements`,
    s1967ea0b8a2b6015: `Exécuter la cellule sélectionnée`,
    s199f5853f4e718f7: `Projets`,
    s24761a0cc8d9c0aa: `Organisation`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Défiler vers le haut`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Ouvrir la boîte de dialogue du sélecteur d'organisation`,
    s2e109263b73c12d5: `Licences`,
    s34d94212c9758944: `Stratégie`,
    s353873ecbaa3efe9: `Flèche de gauche`,
    s3736464cf8d6fa08: `Assistance`,
    s392dc2954562a82b: `Éditeur de texte`,
    s39cccc90e6fe1d7f: `Gestionnaire des problèmes`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Dernière diapositive`,
    s3f809b62bcc2a44c: `Suivi des contrôles`,
    s45efff328e4d0a4d: `Rechercher dans des organisations`,
    s460bf77c46d93bb4: `Fermer la boîte de dialogue des raccourcis`,
    s469437ae00d48e37: `Développer la ligne actuelle`,
    s47de2481b149190a: `Entités`,
    s4802e47fe2e95134: `Option`,
    s480d27b7a8b69ce5: `Défiler vers la gauche`,
    s49ca4bf0e63593da: `Fermer les dialogues`,
    s4b10acae683d2978: `Plein écran`,
    s4b81aa9512692c4d: `Réduire la navigation latérale`,
    s523eb9043213ff0d: `Italique`,
    s56410a6c80d5215c: `Déplacer la cellule vers le bas`,
    s58622fa7922ed03b: `Bouton du menu d'aide`,
    s586d6bd2eca2da93: `Utilisateurs`,
    s5a41c3a63f1c18af: `Paramètres du profil`,
    s5b56a21c08c842c4: `Première diapositive`,
    s5c1ecf88259b79f9: `Présentation`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Cartes de conformité`,
    s5d929ff1619ac0c9: `Rechercher`,
    s5db46d120dcba694: `Évaluations`,
    s5e27738a2e8eb763: `Connexion`,
    s5e8250fb85d64c23: `Fermer`,
    s5febcd9b311c16fe: `Défiler vers la droite`,
    s60565faf8db3a5cb: `Exécuter cette cellule et toutes les cellules au-dessus`,
    s62bc518b503d1c76: `Sélectionner la cellule en dessous`,
    s63b6edf663b6a3c5: `Ajouter une cellule en dessous`,
    s6d5cb7af3fa87c78: `Outil de suivi des tâches`,
    s6db55a42bcb74cfc: `Outil de suivi des problèmes`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `Menu d'aide`,
    s7417792bbe720149: `Répéter`,
    s74cb3d66f6a668e1: `Documentation`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Se déconnecter`,
    s7db511600050e797: `Exécuter cette cellule et toutes les cellules en dessous`,
    s7deaf226ff8b192c: `Installeurs`,
    s7e388025be643d0d: `Entrée`,
    s7eb1e34fc5ece4cd: `Menu Profil`,
    s884bcdca26998a48: `Rapports`,
    s89365ba6fa5cdb97: `Arrêter l'exécution`,
    s89ba33f94f92f3cc: `Campagnes d’identification`,
    s8f4be9f086eb530f: `Annuler`,
    s9021935bcdd703b9: `Ouvrir un panneau latéral`,
    s9373ade6d85b4388: `Réduire la ligne actuelle`,
    s947f21967d65c480: `Marketplace`,
    s9ab2385df7adbce0: `Surligner une ligne`,
    s9dd12575273ac110: `Défiler vers le bas`,
    s9df9510d60035af3: `Ouvrir le menu Profil`,
    s9f26843287bb592d: `Groupes`,
    s9fda4232f5e1876a: `Obtenir de l'aide`,
    sa05b93d8764f88ed: `Gestionnaire des risques`,
    sa103c8e0c776e11c: `Demander des raccourcis clavier`,
    sa153c163bc11460d: `Centre d'activité`,
    sa35ed9234d3d66ce: `Organisations introuvables`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Structure organisationnelle`,
    saed6432f1517ea10: `Gestionnaire des actifs`,
    saf7a5eef69e5bb59: `Flèche vers le haut`,
    sb061ff5a347a296e: `Profil`,
    sb206d700d26b14ff: `Souligner`,
    sb21cca7db5de38f3: `Storyboards`,
    sb284cd019b430d1e: `Aucun raccourci propre à l'application n'est disponible.`,
    sb32c8490570a8831: `Vue d'ensemble des diapositives`,
    sb4484b8d878dffff: `Journaux d'activité`,
    sb752d83c4e4619bc: str `Passer à ${0}`,
    sb888017adf7992b9: `Académie Diligent`,
    sbd63362a31200ab4: `Aller à la Barre de lancement`,
    sbda32dab0c54ffdd: `Diapositive suivante`,
    sbf84c104b8212e06: `Sélectionner la cellule au-dessus`,
    sc203eef710f83583: `Nous ne prenons pas en charge les raccourcis spécifiques pour cette application.`,
    sc2873891e8c3be68: `Éditeur de scripts Robots`,
    sc835e30bc3bdd2fd: `Déplacer la cellule vers le haut`,
    sc8aa5792985e2ba3: `Paramètres de la plateforme`,
    sca1a826088564455: `Résultats`,
    sca442b5dc0fd394c: `Flèche vers le bas`,
    scdd4399eeeacd8f4: `Changer d'organisation`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Sélectionner tout`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Navigation latérale`,
    sd1c09a62f063a73b: `Gestionnaire des tâches`,
    sd514ab1c93237dae: `Plans d'assurance`,
    sd76505ffae553332: `Portail de recherche`,
    sd81eecf773db25fc: `Exécuter toutes les cellules de manière séquentielle`,
    sd8f923198e0c5c6a: `Fin`,
    sd90a1e198e1ac71e: `Échap`,
    sd9fb2375a5c991c5: `Nous ne prenons pas en charge les raccourcis spécifiques pour cette application, cependant si vous avez des suggestions, veuillez nous les communiquer.`,
    sdc599e1d5c823e75: `Sélectionner la dernière cellule`,
    sdcc5f064d591aefd: `Diapositive précédente`,
    se2faf168207b0a48: `Cadres`,
    se3b4c857f91f80d7: `Raccourcis clavier`,
    se65e4e6f3696e997: `Formation`,
    se93a3eaf86201ae7: `Maj`,
    sed2d45e3f811c81d: `Basique`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Supprimer la cellule sélectionnée`,
    sf2d615b20d62225a: `Planificateur`,
    sf41a0c89409353dc: `Flèche de droite`,
    sf5597bb9f2103d2a: `Activations`,
    sf7c0eba7c822e3d6: `Gras`,
    sf95b10c03a2d5872: `Ouvrir la navigation latérale`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Configuration`,
    sfc6b9ce43d2c798c: `Relevés de temps`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Origine`,
};
